

















import Vue from 'vue'
import { mapActions } from 'vuex'
import { UserActionTypes } from '@/store/modules/users/actions'
import { localStorageSet } from '@/helpers/localStorage'
import i18n from '@/i18n'

interface Data {
  languages: string[]
}

interface Methods {
  [UserActionTypes.UpdateCurrentUserLanguage]: (
    lang: string,
  ) => Promise<boolean>
  handleChangeLanguage: (lang: string) => void
}

interface Computed {
  currentLanguage: string
}

export default Vue.extend<Data, Methods, Computed, {}>({
  data() {
    return {
      languages: i18n.availableLocales,
    }
  },
  computed: {
    currentLanguage(): string {
      return i18n.locale
    },
  },
  methods: {
    ...mapActions([UserActionTypes.UpdateCurrentUserLanguage]),
    handleChangeLanguage(lang: string) {
      i18n.locale = lang
      this[UserActionTypes.UpdateCurrentUserLanguage](lang)
      localStorageSet('language', lang)
    },
  },
})
